import { requestUpdateProfile } from 'app/api/account'
import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import UploadImage from 'app/components/common/BaseUpload/components/UploadImage'
import { SectionBase } from 'app/components/common/SectionBase'
import { GenerateWorkInfo } from 'app/components/header/components/profile/ProfileDropdown'
import { ItemInfo } from 'app/containers/TradeUnionMemberManagement/TradeUnionManagementDetails/components'
import { notificationController } from 'app/controllers/notification-controller'
import { IUser } from 'app/model/user.model'
import { useAppDispatch } from 'app/redux/hooks'
import { getUserInfo } from 'app/redux/slices/userSlice'
import { uploadMultipleFiles } from 'app/service/general/service'
import { useState } from 'react'

export const AccountInfoLayout = ({ user }: { user?: IUser }) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useAppDispatch()

  const handleChangeImage = async (imageFile: File) => {
    if (!imageFile) return
    try {
      setLoading(true)
      const files = await uploadMultipleFiles([imageFile])
      if (files?.length) {
        const res = await requestUpdateProfile({ avatar: files?.[0]?.url })
        if (res) {
          dispatch(getUserInfo())
          notificationController.success({
            message: 'Cập nhật ảnh đại diện thành công!',
          })
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  return (
    <SectionBase title="Thông tin tài khoản">
      <BaseRow gutter={[16, 16]} align={'middle'}>
        <BaseCol>
          <UploadImage
            circleLayout
            src={user?.avatar}
            isLoading={loading}
            onChange={handleChangeImage}
            width="100px"
            height="100px"
            textUpload={'Upload logo'}
            alt={user?.full_name}
          />
        </BaseCol>
        <BaseCol xl={18}>
          <BaseSpace>
            <BaseText
              children={user?.full_name}
              fontWeight="semibold"
              fontSize="md"
            />
            <BaseText
              children={`Quyền: ${GenerateWorkInfo({
                roles: user?.roles,
                isTradeUnionMember: user?.isTradeUnionMember,
              })}`}
              fontWeight="medium"
              fontSize="xs"
            />

            <BaseRow gutter={8} align={'middle'}>
              <BaseCol xl={6}>
                <ItemInfo labelKeyI18n={R.strings.email} value={user?.email} />
              </BaseCol>
              <BaseCol xl={6}>
                <ItemInfo
                  labelKeyI18n={R.strings.phone}
                  value={user?.phone ?? '-'}
                />
              </BaseCol>
            </BaseRow>
          </BaseSpace>
        </BaseCol>
      </BaseRow>
    </SectionBase>
  )
}
